var React = require('react');

function PolygonInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("radialGradient",{"id":"radial-gradient","cx":"0.5","cy":"0.5","r":"0.5","gradientUnits":"objectBoundingBox"},[React.createElement("stop",{"offset":"0","stopColor":"#db3594","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#ba2b7d","key":1})])),React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M51.209,13.468a9,9,0,0,1,15.581,0l43.4,75.025A9,9,0,0,1,102.4,102H15.6A9,9,0,0,1,7.812,88.494Z","transform":"translate(118 102) rotate(180)","fill":"url(#radial-gradient)","key":1})]);
}

PolygonInline.defaultProps = {"width":"118","height":"102","viewBox":"0 0 118 102"};

module.exports = PolygonInline;

PolygonInline.default = PolygonInline;
